import styled from '@emotion/styled'

export const BlockContainer = styled.div`
  margin-top: 0;
  display: flex;
  flex-direction: column;
  gap: 0;
`

export const SectionTitle = styled.div`
  font-size: 28px;
  line-height: 34px;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: none;
  color: inherit;
  margin-bottom: 12px;
`

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const FieldLabel = styled.label`
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  letter-spacing: 0.1em;
  text-transform: uppercase;
`

export const AnswersTitle = styled.div`
  font-size: 18px;
  line-height: 24px;
  font-weight: 700;
  color: #000000;
`

export const StyledTextarea = styled.textarea`
  width: 100%;
  max-width: 100%;
  min-height: 64px;
  height: 64px;
  padding: 10px 16px;
  border: 1px solid #c4c4c4;
  border-radius: 25px;
  font-size: 14px;
  line-height: 20px;
  color: rgba(0, 0, 0, 0.85);
  resize: none;
  box-sizing: border-box;
  font-family: inherit;

  &:focus {
    border-color: #40a9ff;
    outline: none;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  }

  &::placeholder {
    color: #7f7f7f;
  }

  &.has-error {
    border-color: #ff4d4f;
  }
`

export const OptionsListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 10px;
`

export const OptionsHeader = styled.div`
  display: grid;
  width: min(912px, 100%);
  max-width: 100%;
  grid-template-columns: 40px 52px minmax(0, 704px) 16px 100px;
  align-items: center;
  min-height: 16px;

  @media (max-width: 900px) {
    width: 100%;
    grid-template-columns: 58px minmax(0, 1fr);
    column-gap: 8px;

    > :nth-child(1) {
      grid-column: 1;
    }

    > :nth-child(2) {
      grid-column: 2;
    }

    > :nth-child(3) {
      display: none;
    }
  }
`

export const OptionsHeaderCell = styled.div`
  font-size: ${({ theme }) => theme.text?.h6?.fontSize ?? '12px'};
  line-height: ${({ theme }) => theme.text?.h6?.lineHeight ?? '16px'};
  font-weight: 400;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #000000;

  &:first-of-type {
    grid-column: 1;
  }

  &:nth-of-type(2) {
    grid-column: 3;
  }

  &:nth-of-type(3) {
    grid-column: 5;
  }

  @media (max-width: 900px) {
    &:first-of-type {
      grid-column: 1;
    }

    &:nth-of-type(2) {
      grid-column: 2;
    }
  }
`

export const OptionRow = styled.div`
  display: grid;
  width: min(912px, 100%);
  max-width: 100%;
  grid-template-columns: 40px 52px minmax(0, 704px) 16px 100px;
  align-items: center;

  > :nth-child(1) {
    grid-column: 1;
  }

  > :nth-child(2) {
    grid-column: 3;
  }

  > :nth-child(3) {
    grid-column: 5;
  }

  @media (max-width: 900px) {
    width: 100%;
    grid-template-columns: 58px minmax(0, 1fr);
    row-gap: 8px;
    column-gap: 8px;
    align-items: start;

    > :nth-child(1) {
      grid-column: 1;
    }

    > :nth-child(2) {
      grid-column: 2;
    }

    > :nth-child(3) {
      grid-column: 2;
    }
  }
`

export const RadioCol = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  input[type='radio'] {
    appearance: none;
    position: relative;
    cursor: pointer;
    margin: 0;
    width: 40px;
    height: 40px;
    border: 1px solid #7b7b7b;
    border-radius: 50%;
    background: #ffffff;
    flex-shrink: 0;

    &:checked {
      border-color: #1d4e89;
      background: radial-gradient(circle, #1d4e89 0 7px, transparent 8px);
    }
  }
`

export const OptionInput = styled.input`
  flex: 1;
  width: 100%;
  height: 40px;
  padding: 10px 16px;
  border: 1px solid #c4c4c4;
  border-radius: 25px;
  font-size: 14px;
  line-height: 20px;
  color: rgba(0, 0, 0, 0.85);
  box-sizing: border-box;
  font-family: inherit;

  &:focus {
    border-color: #40a9ff;
    outline: none;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  }

  &::placeholder {
    color: #7f7f7f;
  }

  &.has-error {
    border-color: #ff4d4f;
  }
`

export const RemoveBtn = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  justify-content: center;
  width: 100px;
  height: 40px;
  padding: 12px;
  border: 1px solid #1d4e89;
  background: white;
  color: #000000;
  font-size: 12px;
  font-weight: 400;
  border-radius: 30px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  white-space: nowrap;
  cursor: pointer;
  flex-shrink: 0;
  line-height: 1;

  span {
    font-size: 12px;
    line-height: 1;
  }

  &:hover {
    background: #ffffff;
    color: #000000;
  }

  svg {
    width: 12px;
    height: 12px;
  }

  @media (max-width: 900px) {
    width: 100%;
    min-width: 0;
  }
`

export const AddButtonWrapper = styled.div`
  margin-top: 0;
  width: 100%;
  display: flex;
  justify-content: flex-start;
`

export const AnswersFieldGroup = styled(FieldGroup)`
  margin-top: 15px;
  gap: 12px;
`

export const AddBtn = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  justify-content: center;
  width: 110px;
  min-width: 110px;
  height: 40px;
  padding: 12px;
  border: 1px solid #1d4e89;
  background: white;
  color: #000000;
  font-size: 12px;
  font-weight: 400;
  border-radius: 30px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  white-space: nowrap;
  cursor: pointer;
  line-height: 1;

  &:hover {
    background: #ffffff;
    color: #000000;
  }

  &:focus-visible {
    outline: 2px solid #1d4e89;
    outline-offset: 1px;
  }

  svg {
    width: 12px;
    height: 12px;
  }
`

export const ErrorText = styled.div`
  font-size: 12px;
  color: #ff4d4f;
  line-height: 1.5;
`
